/**
 * useFunnelRuntimeContext
 *
 * Hook to access the funnel runtime context (session, evaluation, accept/decline).
 * Must be used within a <FunnelRuntimeProvider>.
 */

import { useContext } from 'react'
import { FunnelRuntimeContext } from './funnel-runtime-context'
import type { FunnelRuntimeContextValue } from './funnel-runtime.types'

export function useFunnelRuntimeContext(): FunnelRuntimeContextValue {
  const context = useContext(FunnelRuntimeContext)
  if (context === undefined) {
    throw new Error('useFunnelRuntimeContext must be used within a FunnelRuntimeProvider')
  }
  return context
}
